import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import { MoveToDraftOpportunityErrorModalProps } from './MoveToDraftOpportunityErrorModal.types'
import { UnpublishOpportunityErrorCode } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

export function MoveToDraftOpportunityErrorModal({
  open,
  handleClose,
  errorCode
}: Readonly<MoveToDraftOpportunityErrorModalProps>) {
  const { t } = useTranslation()

  const errorCodesMap: Record<UnpublishOpportunityErrorCode, string> = {
    'opportunity/unpublish_invalid_state': t('errorMessage.moveToDraftOpportunity.unpublishInvalidState'),
    'opportunity/unpublish_has_participants': t('errorMessage.moveToDraftOpportunity.unpublishHasParticipants'),
    'opportunity/unpublish_has_sessions': t('errorMessage.moveToDraftOpportunity.unpublishHasSessions'),
    'opportunity/external': t('errorMessage.moveToDraftOpportunity.externalOpportunity')
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <AcknowledgeModal
        result="negative"
        title={t('typography.volunteering.moveToDraftOpportunityErrorModal.title')}
        description={(errorCode && errorCodesMap[errorCode]) ?? t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
